<template>
  <div class="min-h-svh bg-gray-950">
    <div class="flex justify-center pt-16">
      <NuxtLink to="/">
        <img :src="logo" width="250" height="38" alt="colorize.design" />
      </NuxtLink>
    </div>

    <!-- One clipping box for the plans and the section under them: the glow
         behind the plans is far wider than a phone, and the featured plan hangs
         over the next section's rule. -->
    <div class="isolate overflow-hidden">
      <section class="flow-root pb-16 pt-24 sm:pt-16 lg:pb-0">
        <PageContainer>
          <PricingPlans :tiers="tiers">
            <template #cta="{ tier, frequency }">
              <BaseButton
                :href="tier.custom ? tier.href : getCheckoutLink(tier.id, frequency)"
                :variant="tier.featured ? 'primary' : 'soft'"
                :aria-describedby="tier.id"
              >
                {{ tier.custom ? 'Contact Us' : 'Upgrade' }}
              </BaseButton>
            </template>
          </PricingPlans>
        </PageContainer>
      </section>

      <div class="relative border-t border-gray-800 bg-gray-950">
        <section class="py-24 sm:py-32">
          <PageContainer>
            <BaseCard padding="lg" class="mx-auto max-w-xl">
              <h3 class="text-lg font-semibold leading-8 tracking-tight text-indigo-400">Free Tier</h3>
              <p class="mt-1 text-base leading-7 text-gray-400">100 Successful API calls per month</p>
              <p class="mt-1 text-base leading-7 text-gray-400">10 Requests per hour</p>
              <p class="mt-1 text-base leading-7 text-gray-400">All API capabilities</p>
            </BaseCard>
          </PageContainer>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
// Not indexable — the `noindex` lives in nuxt.config.ts's routeRules. Title and
// description still matter: they're what browsers, tab strips and anyone
// pasting the link in a chat window render.
useHead({
  title: 'Pricing - Colorize Website Data API',
  meta: [
    { name: 'description', content: 'Plans and pricing for programmatic access to website colour palettes, logos, fonts and screenshots.' },
  ],
})

// Add Crisp chat widget
useHead({
  script: [
    {
      innerHTML: `
        window.$crisp=[];
        window.CRISP_WEBSITE_ID="30d15fe3-fa17-4d3d-8eb6-f58560094f9f";
        (function(){
          d=document;
          s=d.createElement("script");
          s.src="https://client.crisp.chat/l.js";
          s.async=1;
          d.getElementsByTagName("head")[0].appendChild(s);
        })();
      `,
      type: 'text/javascript'
    }
  ]
})

import BaseButton from '~/components/atoms/BaseButton.vue'
import BaseCard from '~/components/atoms/BaseCard.vue'
import PageContainer from '~/components/atoms/PageContainer.vue'
import PricingPlans from '~/components/organisms/PricingPlans.vue'
import logo from '~/assets/img/colorize_design_logo.svg'

const getCheckoutLink = (tierId, selectedFrequency) => {
  const baseUrl = "https://buy.stripe.com/";
  if(selectedFrequency==='annually')
    return baseUrl + `00gcNVd0yflA0sUeUX`;
  else{
    return baseUrl + `6oE3dle4Cehw1wY8wy`;
  }

};

const tiers = [
  {
    name: 'Standard',
    id: 'tier-standaert',
    href: '#',
    featured: true,
    description: 'The best financial services for your thriving business.',
    price: { monthly: '$47', annually: '$39' },
    mainFeatures: [
      { label: '1000 Successful API calls', note: '(then 0.04$ each)' },
      '30 Requests per minute',
      'Screenshot API',
      'Logo API',
      'Color Palettes from URL API',
      'Cancel any time',
    ],
  },
  {
    name: 'Enterprise',
    id: 'tier-enterprise',
    href: 'mailto:hi@nestoras.design',
    featured: false,
    custom: true,
    description: 'Convenient features to take your business to the next level.',
    price: { monthly: 'Custom', annually: 'Custom' },
    mainFeatures: ['Custom Volume for API calls', 'Unlimited Requests per minute', 'Service-level agreement (SLA)', 'Dedicated account manager', 'Webhooks and automations'],
  },
]
</script>